import { render, staticRenderFns } from "./SalesEdit.vue?vue&type=template&id=cd70db42&"
import script from "./SalesEdit.vue?vue&type=script&lang=js&"
export * from "./SalesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports